import React, { useState, useEffect } from "react";
import { Row, Col, Card, Typography, message, Divider, Table, Input, Space, Select, Spin } from "antd";
import { SearchOutlined, ReadOutlined, LoadingOutlined, CheckCircleOutlined } from "@ant-design/icons";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useParams } from "react-router-dom";
import { HeaderPage } from "../../../components/headerPage";
import http from "../../../services/http";
const { Text } = Typography;
const antIcon = <LoadingOutlined style={{ fontSize: 18 }} spin />;
const optionsFiltro = [
  { value: 0, label: "Todos" },
  { value: 1, label: "Marcados" },
  { value: 2, label: "Não Marcados" },
];

export const TreinamentosResponsaveis = () => {
  const { id_curso, id_grupo } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  // DADOS
  const [dados, setDados] = useState([]);
  const [selected, setSelected] = useState([]);

  // FILTRO
  const [marcado, setMarcado] = useState(0);
  const [search, setSearch] = useState("");

  // DADOS
  const [curso, setCurso] = useState({});

  useEffect(() => {
    if (id_curso) {
      carregarCurso(id_curso);
      listarColaboradores(id_curso);
    }
  }, [id_curso]);

  // CARREGAR CURSO
  const carregarCurso = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/treinamentos_cursos/carregar/${id}`, []);
    if (api.statusCode === 200) {
      if (!api.response.data) {
        navigate("/treinamentos/grupos");
      }
      setCurso(api.response.data);
    } else {
      navigate("/treinamentos/grupos");
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // LISTAR COLABORADORES
  const listarColaboradores = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/treinamentos_cursos_responsaveis/listar/${id}`, []);
    if (api.statusCode === 200) {
      setDados(api.response.data.data);
      setSelected(api.response.data.checked);
    } else {
      message.error(api.response.message);
      navigate("/treinamentos/grupos");
    }
    setLoading(false);
  };

  // SALVAR COLABORADORES
  const salvarColaboradores = async (colab_selected, colaboradores, id) => {
    setLoading(true);

    let array_colaboradores = [];
    colaboradores?.map((e) => {
      array_colaboradores.push(e.key);
    });

    const dados_envio = {
      id_cad_treinamentos: id,
      id_cursos_responsaveis: array_colaboradores,
      id_cursos_responsaveis_checked: colab_selected,
    };

    const api = await http("post", `v1/treinamentos_cursos_responsaveis/adicionar`, dados_envio);
    if (api.statusCode === 200) {
      setSelected((array) =>
        array.filter(function (x) {
          return array_colaboradores.indexOf(x) < 0;
        })
      );
      setSelected((val) => [...val, ...colab_selected]);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // COLUNAS TABLE
  const columns = [
    {
      title: (
        <div style={{ height: 23 }}>
          Colaborador <Spin indicator={antIcon} spinning={loading} />
        </div>
      ),
      dataIndex: "colaborador",
      sorter: (a, b) => a.colaborador?.localeCompare(b.colaborador),
    },
  ];

  // PESQUISAR
  const handleFilter = (pesquisar, marcado) => {
    let filteredData = dados?.filter((val) => val.colaborador?.toLowerCase().includes(pesquisar.toLowerCase()));

    switch (marcado) {
      case 1:
        filteredData = filteredData.filter((e) => {
          return selected.indexOf(e.id) === -1 ? false : true;
        });
        break;
      case 2:
        filteredData = filteredData.filter((e) => {
          return selected.indexOf(e.id) === -1 ? true : false;
        });
        break;
      default:
        break;
    }

    return filteredData;
  };

  const dadosFilter = dados?.length > 0 ? handleFilter(search, marcado) : [];

  // CHECK ROW
  const rowSelection = {
    type: "checkbox",
    disabled: true,
    selectedRowKeys: selected,
    onSelectAll: (e) => {
      if (loading) return;
      let array = [];
      if (e === true) array = dadosFilter.map((e) => e.key);
      salvarColaboradores(array, dadosFilter, id_curso);
    },
    onSelect: (data, status) => {
      if (loading) return;
      salvarColaboradores(status ? [data.key] : [], [{ key: data.key }], id_curso);
    },
  };

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage
              title="Treinamentos & Desenvolvimento"
              onClickBack={() => navigate(`/treinamentos/grupos/cursos/${id_grupo}`)}
            />
            <HeaderTitle
              title={["Treinamentos & Desenvolvimento", "Responsáveis"]}
              subtitle={
                <Text italic>
                  <ReadOutlined /> {curso?.descricao ?? ""}
                </Text>
              }
              icon={<CheckCircleOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Space direction="vertical">
                <Space wrap>
                  <Input
                    size="middle"
                    maxLength={100}
                    prefix={<SearchOutlined />}
                    className="input"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Pesquisar..."
                    allowClear
                  />
                  <Select
                    defaultValue={0}
                    value={marcado}
                    style={{ width: 180, maxWidth: "100%" }}
                    onChange={(e) => setMarcado(e)}
                    options={optionsFiltro}
                  />
                </Space>
              </Space>

              <Divider />

              <Table
                scroll={{ x: 700 }}
                columns={columns}
                rowSelection={rowSelection}
                dataSource={dadosFilter}
                size="small"
              />
            </Card>
          </div>
        </Col>
      </Col>
    </Row>
  );
};
